import usePaperDownload from "@/hooks/usePaperDownload";
import useTranslation from "@/hooks/useTranslation";
import { CloudDownloadOutlined } from "@ant-design/icons";
import { Popconfirm, Spin, Tag } from "antd";
import React from "react";
import styles from "../styles.module.less";

const { itemContainer, itemIcon, itemText, downloadStyle } = styles;

interface CardProps {
  oa_locations: {
    url: string;
    url_for_pdf: string;
    url_for_landing_page: string;
    repository_institution: string;
  }[];
  loading: boolean;
  doi: string;
}

const DownloadCard: React.FC<CardProps> = ({ oa_locations, loading, doi }) => {
  return (
    <Spin spinning={loading}>
      <div className={downloadStyle}>
        {oa_locations?.map((location) => (
          <Tag key={location.url}>
            <a
              href={
                location.url_for_pdf ||
                location.url ||
                location.url_for_landing_page
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              {location.repository_institution?.split(/\W/)[0] || "Download"}
            </a>
          </Tag>
        ))}
        <Tag>
          <a
            href={`https://sci.medicgo.org/${doi}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Sci-Hub(MO)
          </a>
        </Tag>
        <Tag>
          <a
            href={`https://sci-hub.se/${doi}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Sci-Hub(TW)
          </a>
        </Tag>
      </div>
    </Spin>
  );
};

interface IProps {
  doi: string;
}

const Download: React.FC<IProps> = ({ doi }) => {
  const { t } = useTranslation("explore");
  const { loadDownload, data, loading } = usePaperDownload(doi);

  const handleClick = () => {
    loadDownload();
  };

  return (
    <Popconfirm
      title={
        <DownloadCard
          doi={doi}
          oa_locations={data?.eDownload?.oa_locations}
          loading={loading}
        />
      }
      okText="Yes"
      cancelText="No"
      icon={null}
    >
      <div className={itemContainer} onClick={() => handleClick()} key={doi}>
        <div className={itemIcon}>
          <CloudDownloadOutlined />
        </div>
        <div className={itemText}>{t("tab.helper.download")}</div>
      </div>
    </Popconfirm>
  );
};

export default Download;
